import {
  KeyboardArrowLeft,
  KeyboardArrowRight,
  Pause,
  PlayArrow,
} from '@mui/icons-material';
import { IconButton, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useCarouselControls } from './item-carousel-controls.hooks';

const ItemCarouselControls = () => {
  const { t } = useTranslation();
  const { stopped, play, stop, slideNext, slidePrev } = useCarouselControls();

  return (
    <Stack slot="container-end" direction="row" justifyContent="flex-end">
      <IconButton
        aria-label={
          stopped
            ? t('recommendations.swiper.play')
            : t('recommendations.swiper.pause')
        }
        size="small"
        onClick={() => {
          stopped ? play() : stop();
        }}
      >
        {stopped ? <PlayArrow fontSize="small" /> : <Pause fontSize="small" />}
      </IconButton>
      <IconButton
        aria-label={t('recommendations.swiper.previous')}
        size="small"
        onClick={() => {
          slidePrev();
        }}
      >
        <KeyboardArrowLeft fontSize="small" />
      </IconButton>
      <IconButton
        aria-label={t('recommendations.swiper.next')}
        size="small"
        onClick={() => {
          slideNext();
        }}
      >
        <KeyboardArrowRight fontSize="small" />
      </IconButton>
    </Stack>
  );
};
export default ItemCarouselControls;
